import { createStore } from '../storage/indexedDb';
import { trackEvent } from '../events';

export type AuditRecord = {
	id: string;
	ts: number;
	actor: string | null;
	action: string;
	resource?: string;
	metadata?: Record<string, unknown>;
};

const store = createStore('audit');
const KEY = 'audit.v1';

async function load(): Promise<AuditRecord[]> {
  const items = await store.get(KEY);
  return (items as AuditRecord[] | null) || [];
}
async function save(items: AuditRecord[]): Promise<void> { await store.set(KEY, items); }

function genId(): string { return Math.random().toString(36).slice(2) + Date.now().toString(36); }

export async function logAudit(actor: string | null, action: string, resource?: string, metadata?: Record<string, unknown>): Promise<AuditRecord> {
	const rec: AuditRecord = { id: genId(), ts: Date.now(), actor, action, resource, metadata };
	const items = await load();
	await save([rec, ...items].slice(0, 1000));
	trackEvent('scout.audit', { action, resource: resource || '', actor: actor || '' });
	return rec;
}

export async function listAudit(limit = 200): Promise<AuditRecord[]> {
	const items = await load();
	return items.slice(0, limit);
}


